module.exports = __webpack_public_path__ + "img/mail.6fb701fa.svg";